<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white">
      {{ isNewProperty ? 'New ' : '' }}Property
    </div>
    <div class="card-body">
      <LoadingSpinner v-if="submitting" message ='Saving Property' size = '1x'>
      </LoadingSpinner>
      <template v-if="!submitting">
        <div class="form-group row">
          <label for="propertyName" class="col-lg-4 col-form-label label-text">
            Property Name
          </label>
          <div class="col-lg-8">
            <input data-vv-as="Property Name"
                    type="text"
                    class="form-control"
                    name="propertyName"
                    v-model="property.name"
                    placeholder="Enter Property Name"
                    maxlength="50" />
            <small v-if="!errors.first('propertyName')" class="form-text text-muted">
              Max 50 characters
            </small>
            <div class="invalid-feedback">{{ errors.first('propertyName') }}</div>
          </div>
        </div>
        <div class="form-group row">
          <label for="primaryLocality" class="col-lg-4 col-form-label label-text">
            <span class="text-danger">*</span>Primary Locality
          </label>
          <div class="loading col-lg-5" v-if="loading">
            Loading...
          </div>
          <div class="col-lg-8">
            <select v-if="!loading"
                    v-validate="'required'"
                    data-vv-as="Primary Locality"
                    class="form-control"
                    name="primaryLocality"
                    v-model="property.propertyLocalities[0].localityId">
              <option value="" disabled>Select Locality</option>
              <option
                v-for="option in unselectedLocalities(property.propertyLocalities[0].localityId)"
                :key="option.id"
                :value="option.id">
              {{ option.name }}
              </option>
            </select>
            <div class="invalid-feedback">{{ errors.first('primaryLocality') }}</div>
          </div>
        </div>
        <div v-for='(additionalLocale, index) in this.property.propertyLocalities.slice(1)'
                  :key='index'>
          <div class="form-group row">
            <div class="col-lg-4 label-text">
              <span v-if='index === 0'>Additional Localities</span>
            </div>
            <div class="input-group col-lg-8">
              <select v-if="!loading"
                      v-validate="'required'"
                      data-vv-as="Additional Locality"
                      class="form-control"
                      name="additionalLocale"
                      v-model="additionalLocale.localityId">
                <option value="" disabled>Select Locality</option>
                <option v-for="option in unselectedLocalities(additionalLocale.localityId)"
                        :key="option.id"
                        :value="option.id">
                {{ option.name }}
                </option>
              </select>
              <a class="form-action-icon text-danger"
                    @click='removeAdditionalLocality(index + 1)'>
                <font-awesome-icon icon='trash-alt' />
              </a>
              <div class="invalid-feedback" v-if="errors.first('additionalLocale')">
                Select Additonal Locality or remove this row.
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <b-button size="sm" @click="addAdditionalLocality()">
          Add Additional Locality
        </b-button>
      </template>
    </div>
    <slot name="submitForm"></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import api from '../api';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'PropertyForm',
  components: {
    LoadingSpinner,
  },
  props: [
    'property',
    'isNewProperty',
    'submitting',
  ],
  // this injects the parent page's validator
  inject: ['$validator'],
  created() {
    this.$store.dispatch(`${LookupModules.LOCALITIES.namespace}/fetchOptions`, LookupModules.LOCALITIES.url);
  },
  computed: {
    ...mapState(LookupModules.LOCALITIES.namespace, {
      loading: state => state.loading,
      serverError: state => state.serverError,
    }),
    ...mapGetters(LookupModules.LOCALITIES.namespace, {
      localityOptions: 'getActiveOptions',
    }),
  },
  methods: {
    addAdditionalLocality() {
      this.property.propertyLocalities.push({ localityId: '', primary: false });
    },
    removeAdditionalLocality(index) {
      this.property.propertyLocalities
        .splice(index, 1);
    },
    unselectedLocalities(selectedLocaleId) {
      return this.localityOptions.filter(option => selectedLocaleId === option.id
        || (option.id !== this.property.propertyLocalities[0].localityId
          && !this.property.propertyLocalities.some(locale => option.id === locale.localityId)));
    },
    getLocalities() {
      this.loading = true;
      api.get('/locality/localities')
        .then((response) => {
          this.localityOptions = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
